import { render, staticRenderFns } from "./PinPurchaseHistory.vue?vue&type=template&id=736d2b0b&"
import script from "./PinPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./PinPurchaseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports